import { EmailCreateFormValues } from '~/core/shared/types';

export const emailCreateDefaultFormValues: EmailCreateFormValues = {
  bcc: '',
  content: '',
  subject: '',
};
